import type { NavigateFunction } from 'react-router-dom';

import { getMeOnboarding, onboardingPending } from '../widget-api/auth-onboarding';
import { getMe } from '../widget-api/auth-me';
import { PATH } from './path-routes';
import { initPushRegistration, registerPushTokenIfPresent } from './push-token-register';

/**
 * После client-login: при необходимости онбординга — на `/agreements`,
 * затем при неподтверждённом email — на `/confirm-email`, иначе на расписание.
 * Параллельно (best-effort) регистрируем push-токен устройства.
 */
export async function navigateAfterClientAuth(
  _navigate: NavigateFunction,
  searchSuffix: string,
  accessToken: string,
  organizationId: number | null
): Promise<void> {
  // Регистрация push-токена устройства на каждом входе клиента (не блокирует).
  void initPushRegistration();
  void registerPushTokenIfPresent();
  const suffix = searchSuffix.startsWith('?') ? searchSuffix : searchSuffix ? `?${searchSuffix}` : '';
  try {
    const ob = await getMeOnboarding(organizationId, accessToken);
    if (onboardingPending(ob)) {
      window.location.href = `/embed${PATH.agreements}${suffix}`;
      return;
    }
  } catch {
    /* если onboarding недоступен — не блокируем вход */
  }
  try {
    const me = await getMe(accessToken);
    if (!me.email_verified_at && me.email_verification_available) {
      window.location.href = `/embed${PATH.confirmEmail}${suffix}`;
      return;
    }
  } catch {
    /* если me недоступен — не блокируем */
  }
  window.location.href = `/embed${PATH.schedule}${suffix}`;
}
